import { render, staticRenderFns } from "./areAndDepartmentRightDataWidthFit.vue?vue&type=template&id=412c1053&scoped=true&"
import script from "./areAndDepartmentRightDataWidthFit.vue?vue&type=script&lang=js&"
export * from "./areAndDepartmentRightDataWidthFit.vue?vue&type=script&lang=js&"
import style0 from "./areAndDepartmentRightDataWidthFit.vue?vue&type=style&index=0&id=412c1053&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412c1053",
  null
  
)

export default component.exports